export class MarketingStatsFilter {
    companyIds: number[] | null;
    productIds: number[] | null;
    countryIsoCodes: number[] | null;
    platform: number;

}
